<template>
	<v-container fluid fill-height class="container">
		<v-layout wrap>
			<v-flex xs12 md6 class="flex-login">
				<LoginForm />
			</v-flex>

			<v-flex xs12 md6 class="flex-information">
				<div class="information">
					<div>
						<h1 class="white--text">
							Gestão inteligente para sua Home Care.
						</h1>
						<p>
							O CareYes surgiu para acabar com planilhas e reduzir a “papelada” nas empresas de
							Home Care e Assistência Domiciliar de Saúde.
						</p>
					</div>
				</div>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import LogoCareyes from '@Assets/images/logo-careyes.png';
import LoginForm from './login-form';

export default {
  name: 'Login',
  components: {
    LoginForm
  },
  data: () => ({
    logo: LogoCareyes
  })
};
</script>

<style scoped lang='scss'>
@import "@Assets/css/settings.scss";

.container {
  padding: 0;
  color: $font-color;

  .layout {
    flex-direction: row;

    .flex-login {
      order: 1;

      @media screen and (min-width: $break-point-md) {
        order: 0;
      }
    }

    .flex-information {
      order: 0;

      @media screen and (min-width: $break-point-md) {
        order: 1;
      }

      .information {
        display: flex;
        padding: 50px;
        background: $cy-gradient-strong,
          url("../../assets/images/care-background.jpg");
        background-size: cover;
        color: #fff;
        align-items: center;
        justify-content: center;
        height: 100%;

        @media screen and (min-width: $break-point-md) {
          padding: 25px;
        }

        div {
          max-width: 430px;

          p {
            display: none;
            margin-top: 25px;
            line-height: 25px;
            font-size: 15px;

            @media screen and (min-width: $break-point-sm) {
              display: block;
            }
          }
        }
      }
    }
  }
}
</style>
